import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import ButtonUnderline from './ButtonUnderline'


const Container = styled.div`
   width: 100%;
	overflow: hidden;
	display: flex;
	@media (min-width : ${brk.S}) and (max-width : ${brk.M}){
		flex-direction: column;
	}
	@media (max-width : ${brk.S}) {
		flex-direction: column;
	}
   
`;

const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
    padding : 5px;
	min-height: inherit;
	position: relative;
	display: block;
	background-size: cover !important;
	background-position : center !important;
	
	@media (max-width : ${brk.S}) {
		padding : 5px 10px;
	}
	    

`;

const HalfpageOne = styled.div`
    width: 50%;
	background: black;
	@media (min-width : ${brk.S}) and (max-width : ${brk.M}){
		width: 100%;
	}
	@media (max-width : ${brk.S}) {
		width: 100%;
	}
    
    display: flex;
        flex-direction: row;
        @media (max-width : ${brk.S}) {
            flex-direction: column;
        }
`;
const HalfpageTwo = styled.div`
	display: flex;
	width: 50%;
	background: black;
	@media (min-width : ${brk.S}) and (max-width : ${brk.M}){
		width: 100%;
	}
	@media (max-width : ${brk.S}) {
		width: 100%;
	}

`;
const BlockOne = styled.a`
    width: 50%;
	height: 25vw;
	flex-direction: row;
	@media (min-width : ${brk.S}) and (max-width : ${brk.M}){
		height: 50vw;
	}
	@media (max-width : ${brk.S}) {
		width: 100%;
		height: 200px;
	}
    & div{
    
    }

`;
const BlockTwo = styled.a`
    width: 50%;
	height: 25vw;
	flex-direction: row;
	@media (min-width : ${brk.S}) and (max-width : ${brk.M}){
		height: 50vw;
	}
	@media (max-width : ${brk.S}) {
		width: 100%;
		height: 200px;
	}
    & div{
    
    }
`;
const BlockThree = styled.a`
    width: 100%;
    height: 25vw;
    
    @media (min-width : ${brk.S}) and (max-width : ${brk.M}){
        height: 50vw;
    }
    @media (max-width : ${brk.S}) {
        width: 100%;
        height: 200px;
    }   
`;

const Cadre = styled.div`
    position : relative;
    border: 2px solid white;
    background: rgba(0,0,0,0.3);
 	width: 100%;
 	height: 100%;
 	cursor: pointer;
 	-webkit-transition: background 1s, border-color 1s,-webkit-transform 1s;
	  transition: background 1s, border-color 1s,transform 1s;
	
	&:hover{
        background: rgba(0,0,0,0.8);
        border-color: rgba(255,255,255,0);
        
        &::after, &::before {
          -webkit-transform: scale(1);
        }
    }
    
    &::before, &::after {
      width: 100%;
      height:100%;
      z-index: 3;
      content:'';
      position: absolute;
      top:0;
      left:0;
      box-sizing: border-box;
      -webkit-transform: scale(0);
      transition: 1s;
    }
    
    &::before {
      border-bottom: 3px solid #FD9D87;
      border-left: 3px solid #FD9D87;
      -webkit-transform-origin: 0% 100%;
    
    }
    
    &::after {
      border-top: 3px solid #FD9D87;
      border-right: 3px solid #FD9D87;
      -webkit-transform-origin: 100% 0%;
    }

		@media (max-width : ${brk.S}) {
			margin-bottom: 5px;
		}
		
		
	& h3{
        font-family : 'Cormorant',serif;
        text-transform: uppercase;
		font-size: 32px;
		font-weight : 600;
        color: white;
        width: 90%;
        margin: auto;
        text-align: center;
        margin-top: 10.5vw;
        -webkit-transition: color 1s;
        transition: color 1s;
    
        @media (min-width : ${brk.S}) and (max-width : ${brk.M}){
            margin-top: 22vw;
        }
        @media (max-width : ${brk.S}) {
            margin-top:70px;
        }
    }	
`;



class ThreeBlocks extends Component {
    render() {
        const {
            content
        } = this.props;
        console.log('content : ', content);

        const content1 = content[0];
        const content2 = content[1];
        const content3 = content[2];




        return (
            <Container >
                <HalfpageOne>
                    <BlockOne href={content1.buttonLink}>
                        <BackgroundImage  style={{ background: `url(${content1.images[0].fluid.src})`}}
                        >
                            <Cadre>
                                <h3>{ content1.buttonLabel}</h3>
                            </Cadre>


                        </BackgroundImage>
                    </BlockOne>
                    <BlockTwo href={content2.buttonLink}>
                        <BackgroundImage  style={{ background: `url(${content2.images[0].fluid.src})`}}
                        >
                            <Cadre>
                                <h3>{ content2.buttonLabel}</h3>
                            </Cadre>
                        </BackgroundImage>
                    </BlockTwo>
                </HalfpageOne>
                <HalfpageTwo>
                    <BlockThree href={content3.buttonLink}>
                        <BackgroundImage  style={{ background: `url(${content3.images[0].fluid.src})`}}
                        >
                            <Cadre>
                                <h3>{ content3.buttonLabel}</h3>
                            </Cadre>
                        </BackgroundImage>
                    </BlockThree>
                </HalfpageTwo>
            </Container>
        )
    }
}


export default ThreeBlocks;